import { DocumentArrowDownIcon } from '@heroicons/react/24/outline/index.js'
import { TooltipTrigger } from '../../../Provider/TooltipManager.js'
import type { OrderNotice } from '../../../Generated/OrderNotice.ts'
import { AlertMarker } from '../../Component/OrderAlert/AlertMarker.tsx'

interface ReportDownloadButtonProps {
  onClick: () => void
  title: string
  classNames: string
  disabled?: boolean
  disabledTooltip?: string
  notices?: OrderNotice[]
}

export const ReportDownloadButton = (props: ReportDownloadButtonProps) => {
  return (
    <TooltipTrigger tooltip={''} disabled={props.disabled} disabledTooltip={props.disabledTooltip}>
      <div className="flex flex-col items-center w-20 text-center">
        <button
          data-testid="download-report"
          onClick={props.onClick}
          disabled={props.disabled === true}
          className={props.disabled === true ? 'cursor-not-allowed' : ''}
        >
          <DocumentArrowDownIcon className={`w-8 h-8 ${props.disabled === true ? 'text-gray-300' : props.classNames}`} />
        </button>
        <span className={`text-xs inline-flex items-center gap-1 ${props.disabled === true ? 'text-gray-400' : ''}`}>
          {props.title}
          <AlertMarker items={props.notices ?? []} className="w-3.5 h-3.5" />
        </span>
      </div>
    </TooltipTrigger>
  )
}
